import Vue from 'vue'
import persianDate from 'persian-date'

/**
 * Device filter utility functions
 */

// Helper to get Persian date calculations
const getPersianDateHelper = () => {
  return persianDate || null
}

/**
 * Get filter label in Persian
 */
export const getFilterLabel = filterType => {
  const labels = {
    all: 'همه دستگاه‌ها',
    active: 'دستگاه‌های فعال',
    disabled: 'دستگاه‌های غیرفعال',
    expired: 'دستگاه‌های منقضی شده',
    expiredButActive: 'منقضی شده در حال استفاده',
    expiredAndDisabled: 'منقضی شده بدون استفاده',
    assigned: 'دستگاه‌های واگذار شده',
    unassigned: 'دستگاه‌های بدون کاربر',
    expiredLast1Month: 'منقضی شده در 1 ماه گذشته',
    expiredLast3Months: 'منقضی شده در 3 ماه گذشته',
    expiredLast6Months: 'منقضی شده در 6 ماه گذشته',
    expiredMoreThan6Months: 'منقضی شده بیش از 6 ماه',
  }
  return labels[filterType] || filterType
}

/**
 * Apply filter to devices array
 */
export const applyDeviceFilter = (devices, filterType) => {
  if (!filterType || filterType === 'all') {
    return devices
  }

  // Get today's date in Persian format
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  const today = new Date().toLocaleDateString('fa-IR', options).replaceAll('/', '')
  const todayNumber = parseInt(Vue.prototype.$functions.toEnNumbers(today))

  // Calculate date ranges for time-based filters
  let oneMonthAgo = null
  let threeMonthsAgo = null
  let sixMonthsAgo = null

  // Try to calculate Persian dates
  try {
    const persianDate = getPersianDateHelper()
    if (persianDate) {
      const pd = new persianDate()
      oneMonthAgo = pd.subtract('month', 1).format('YYYYMMDD')
      const pd2 = new persianDate()
      threeMonthsAgo = pd2.subtract('month', 3).format('YYYYMMDD')
      const pd3 = new persianDate()
      sixMonthsAgo = pd3.subtract('month', 6).format('YYYYMMDD')
    } else {
      // Fallback: approximate calculation
      const now = new Date()
      const oneMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate())
      const threeMonthDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate())
      const sixMonthDate = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate())

      oneMonthAgo = oneMonthDate.toLocaleDateString('fa-IR', options).replaceAll('/', '')
      threeMonthsAgo = threeMonthDate.toLocaleDateString('fa-IR', options).replaceAll('/', '')
      sixMonthsAgo = sixMonthDate.toLocaleDateString('fa-IR', options).replaceAll('/', '')

      oneMonthAgo = Vue.prototype.$functions.toEnNumbers(oneMonthAgo)
      threeMonthsAgo = Vue.prototype.$functions.toEnNumbers(threeMonthsAgo)
      sixMonthsAgo = Vue.prototype.$functions.toEnNumbers(sixMonthsAgo)
    }
  } catch (error) {
    // console.error('Error calculating Persian dates:', error)
  }

  return devices.filter(device => {
    switch (filterType) {
      case 'active':
        return !device.disabled

      case 'disabled':
        return device.disabled

      case 'expired':
        return device.expire === -1

      case 'expiredButActive':
        return device.expire === -1 && !device.disabled

      case 'expiredAndDisabled':
        return device.expire === -1 && device.disabled

      case 'assigned':
        return device.userId !== undefined && device.userId !== null

      case 'unassigned':
        return device.userId === undefined || device.userId === null

      case 'expiredLast1Month': {
        if (!oneMonthAgo) return false
        const expireString = (device.expireTime || '').replace(/\//g, '')
        const expireNumber = parseInt(expireString)
        return expireNumber >= parseInt(oneMonthAgo) && expireNumber < todayNumber
      }

      case 'expiredLast3Months': {
        if (!threeMonthsAgo) return false
        const expireString = (device.expireTime || '').replace(/\//g, '')
        const expireNumber = parseInt(expireString)
        return expireNumber >= parseInt(threeMonthsAgo) && expireNumber < todayNumber
      }

      case 'expiredLast6Months': {
        if (!sixMonthsAgo) return false
        const expireString = (device.expireTime || '').replace(/\//g, '')
        const expireNumber = parseInt(expireString)
        return expireNumber >= parseInt(sixMonthsAgo) && expireNumber < todayNumber
      }

      case 'expiredMoreThan6Months': {
        if (!sixMonthsAgo) return false
        const expireString = (device.expireTime || '').replace(/\//g, '')
        const expireNumber = parseInt(expireString)
        return expireNumber < parseInt(sixMonthsAgo)
      }

      default:
        return true
    }
  })
}

export default {
  getFilterLabel,
  applyDeviceFilter,
}